import {
  FabricEditor,
  fillGradientPlugin,
  fontLoadingPlugin,
  gridPlugin,
  layerPlugin,
  rectCornersPlugin,
  selectionPlugin,
} from 'modules/fabric-editor';
import type { Object as FabricObject } from 'fabric/fabric-impl';
import { layoutBlocksPlugin } from 'modules/manager/domain/layout-blocks';
import { rebaseAssetUrls } from 'modules/manager/domain/template-file';
import { placeholderPlugin } from 'modules/manager/domain/placeholder';

/**
 * Plugin set for an off-screen canvas that only has to *draw* a template — no selection UI,
 * no grid. Used by the preset thumbnail preview; the render itself lives on the backend
 * (`POST /api/render-template`), see `.claude/docs/media-manager-server-render.md`.
 */
export const RENDER_PLUGINS = [
  selectionPlugin(),
  layerPlugin(),
  gridPlugin({ visible: false }),
  rectCornersPlugin(),
  fillGradientPlugin(),
  fontLoadingPlugin(),
  placeholderPlugin(),
  layoutBlocksPlugin(),
];

export function loadCanvasJson(editor: FabricEditor, version: unknown, objects: unknown[]): Promise<void> {
  // Same as the editor restore: the logo `src` may point at the stand the template was saved on.
  const rebased = rebaseAssetUrls(objects as FabricObject[], window.location.origin);
  return new Promise((resolve) => {
    editor.canvas.loadFromJSON({ version, objects: rebased }, () => {
      editor.canvas.renderAll();
      editor.emit('canvas:loaded', { source: 'render' });
      resolve();
    });
  });
}

export function nextFrame(): Promise<void> {
  return new Promise((resolve) => {
    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(() => resolve());
    } else {
      setTimeout(resolve, 16);
    }
  });
}
